import React, { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { joinWaitlist } from "@/lib/api";
import { Sparkles } from "lucide-react";

const WaitlistContext = createContext(null);
export const useWaitlist = () => useContext(WaitlistContext);

export function WaitlistProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState("General");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const openWaitlist = (prod = "General") => {
    setProduct(prod);
    setOpen(true);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await joinWaitlist({ email, product, name: name || null });
      toast.success(res.message || "You're on the list!");
      setOpen(false);
      setEmail("");
      setName("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WaitlistContext.Provider value={{ openWaitlist }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="waitlist-dialog"
          className="rounded-[24px] border-[#4B2E5A]/10 bg-[#FCFAF7] p-8 max-w-md"
        >
          <DialogHeader>
            <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F28C82]/15">
              <Sparkles className="h-6 w-6 text-[#F28C82]" strokeWidth={1.5} />
            </div>
            <DialogTitle className="font-heading text-2xl font-medium text-[#4B2E5A]">
              Join the {product === "General" ? "Naari Sutra" : product} waitlist
            </DialogTitle>
            <DialogDescription className="text-[#4B2E5A]/60">
              Be the first to experience AI that decides with you. We'll email you the moment it's ready.
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="mt-2 space-y-4">
            <Input
              data-testid="waitlist-name-input"
              placeholder="Your name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="rounded-full border-[#4B2E5A]/15 bg-white px-5 py-6 text-[#4B2E5A]"
            />
            <Input
              data-testid="waitlist-email-input"
              type="email"
              required
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-full border-[#4B2E5A]/15 bg-white px-5 py-6 text-[#4B2E5A]"
            />
            <Button
              data-testid="waitlist-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#4B2E5A] py-6 text-[#FCFAF7] hover:bg-[#4B2E5A]/90"
            >
              {loading ? "Joining..." : "Join Early Access"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </WaitlistContext.Provider>
  );
}
